var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 31,
    viewBox: "0 0 28 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4396 4.85667C20.2623 3.51268 19.6135 1.78669 19.614 0H14.2924V21.3556C14.2513 22.5112 13.7634 23.6058 12.9314 24.4089C12.0994 25.212 10.9882 25.6609 9.8318 25.6611C7.38625 25.6611 5.35403 23.6633 5.35403 21.1833C5.35403 18.2211 8.21291 15.9994 11.1579 16.9122V11.47C5.21625 10.6778 0.0151367 15.2933 0.0151367 21.1833C0.0151367 26.9183 4.76847 31 9.81458 31C15.2224 31 19.614 26.6083 19.614 21.1833V10.3506C21.772 11.9003 24.3628 12.7318 27.0196 12.7272V7.40556C27.0196 7.40556 23.7818 7.56056 21.4396 4.85667Z",
    fill: "#01126E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.f969998d5071c629b8e75076373c0d5a.svg";
export { ForwardRef as ReactComponent };